import 'css-chunksrc/client/scenes/documentUpload/dropZone/styles.scss';export default {};